import { createApp, ref } from 'vue'
import App from './App.vue'
import router from './router'
import Vant from 'vant'
import { Lazyload } from 'vant' // vant图片懒加载
import store from './store'
import 'vant/lib/index.css'
import touchEmulator from './utils/touch-emulator'

// 初始化触摸事件模拟器，使 Vant 组件在 PC 环境下正常工作
touchEmulator()

// Android事件（百度）— App通过JSBridge调用此全局方法，暂存设备信息供下单/注册使用
window.yourJsFunction = function(jsonString) {
    let deviceInfo = null
    try {
        deviceInfo = JSON.parse(jsonString)
    } catch (e) {
        deviceInfo = null
    }
    if (deviceInfo) {
        localStorage.setItem('baiduJson', jsonString)
    }
    return jsonString // 原样返回给App
}

// 创建全局状态管理
const globalState = {
  isPopupVisible: ref(false) // 是否有弹窗正在显示
}

const app = createApp(App)
app.provide('globalState', globalState)
app.use(router)
app.use(Vant)
// app.use(Vant.Lazyload)
app.use(Lazyload)
app.use(store)

app.mount('#app')